<template>
  <ul class="navbar-nav mr-auto">
    <li class="nav-item dropdown">
      <a
        href="#"
        class="nav-link dropdown-toggle"
        :class="{ 'router-link-active': $route.path.startsWith('/alert') }"
        data-toggle="dropdown"
        >Alerts</a
      >
      <div class="dropdown-menu">
        <router-link to="/alert/my-alerts" class="dropdown-item"
          >My Alerts</router-link
        >
        <router-link to="/alert/provider-alert" class="dropdown-item"
          >{{ $filters.providerLabel("singular", true) }} Alerts</router-link
        >
        <router-link to="/alert/client-alert" class="dropdown-item"
          >{{ $filters.customerLabel("singular", true) }} Alerts</router-link
        >
        <router-link to="/alert/calendar-view" class="dropdown-item"
          >Calendar View</router-link
        >
      </div>
    </li>
  </ul>
</template>
